@use "../../../globals/settings";
@use "../../../globals/bcp-2022/objects/links";
@use "../../../globals/bcp"; /* TTRQ-54629 custom */
@use "../../../globals/libs/clickdummy/core/styles/variables/colors.scss"; /* TT Custom */

:host {
  display: inline-flex;
}

a:not([class]),
a[class=""] {
  @include links.inline;
}

.a-link {
  @include links.standalone;

  &--primary {
    @include links.primary;
  }

  &--disabled {
    @include links.disabled;
  }

  &--with-parts {
    @include links.with-icon();
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable no-descending-specificity */

.a-link {
  &--custom {
    font-size: 1rem;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    gap: 0.25rem;
    margin-top: 4px;

    @include bcp.set-css-var(link, color, bcp.colorVar("link-text"));
    @include bcp.set-css-var(link-hover, color, bcp.colorVar("link-text"));
  }

  &--custom-invoice,
  &--custom-invoice-small {
    gap: 0.3rem;

    @include bcp.theme("buderus") {
      @include bcp.set-css-var(link, color, bcp.colorVar("link-text"));
      @include bcp.set-css-var(link-hover, color, bcp.colorVar("link-text"));
    }

    @include bcp.theme("bosch", "vulcano", "ivt") {
      @include bcp.set-css-var(
        link,
        color,
        colors.$color-blue-dark-bahama-blue
      );
      @include bcp.set-css-var(
        link-hover,
        color,
        colors.$color-blue-dark-bahama-blue
      );
    }

    &:hover,
    &:active {
      text-decoration: none;
    }
  }

  &--custom-invoice-small {
    font-size: 0.875rem;
  }
}
